import { useQuery } from '@apollo/client/react';
import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';

import { PageContentRoot } from '#components/page-content-root/page-content-root';
import { ProcessorInstancesTable } from '#components/processor-instances-table/processor-instances-table';
import { GET_PROCESSOR_INSTANCES } from '#graphql/queries/processor-instances-list';

export function ProcessorInstancesListPage() {
  const { data, loading, error, refetch } = useQuery(GET_PROCESSOR_INSTANCES, {
    variables: { limit: 200 },
  });

  const rows = data?.processorInstances ?? [];

  if (loading && !data) {
    return (
      <PageContentRoot>
        <Heading size="lg" color="fg" mb={6}>
          Processor instances
        </Heading>
        <Text>Loading…</Text>
      </PageContentRoot>
    );
  }

  if (error) {
    return (
      <PageContentRoot>
        <Heading size="lg" color="fg" mb={6}>
          Processor instances
        </Heading>
        <Text color="red.500">Error loading instances: {error.message}</Text>
        <Button onClick={() => void refetch()} mt={4}>
          Retry
        </Button>
      </PageContentRoot>
    );
  }

  return (
    <PageContentRoot>
      <VStack gap={6} align="stretch">
        <Box>
          <Heading size="lg" color="fg" mb={1}>
            Processor instances
          </Heading>
          <Text fontSize="sm" color="fg.muted">
            Your recent processor runs (newest first). At most 200 shown.
          </Text>
        </Box>

        <ProcessorInstancesTable
          rows={rows}
          loading={loading}
          showProcessorColumn
        />
      </VStack>
    </PageContentRoot>
  );
}
